import { DEFAULT_GLOBAL_STATE, ENTITIES } from "./entities";

export const SCENE_STATES = {
	SPLASH_SCREEN: {
		audio: [],
		video: [],
	},
	CABIN_HUB: {
		audio: [
			DEFAULT_GLOBAL_STATE[ENTITIES.FIREPLACE.CABIN],
			DEFAULT_GLOBAL_STATE[ENTITIES.WEATHER.CABIN],
		],
		video: [
			DEFAULT_GLOBAL_STATE[ENTITIES.FIREPLACE.CABIN],
			DEFAULT_GLOBAL_STATE[ENTITIES.WEATHER.CABIN],
			DEFAULT_GLOBAL_STATE[ENTITIES.TV.CABIN],
		],
	},
	CABIN_CAT: {
		audio: [DEFAULT_GLOBAL_STATE[ENTITIES.FIREPLACE.CABIN]],
		video: [],
	},
	CABIN_COUCH: {
		audio: [DEFAULT_GLOBAL_STATE[ENTITIES.FIREPLACE.CABIN]],
		video: [
			DEFAULT_GLOBAL_STATE[ENTITIES.FIREPLACE.CABIN],
			DEFAULT_GLOBAL_STATE[ENTITIES.TV.CABIN],
		],
	},
	CABIN_GAME_TABLE: {
		audio: [DEFAULT_GLOBAL_STATE[ENTITIES.FIREPLACE.CABIN]],
		video: [],
	},
	CABIN_FIREPLACE: {
		audio: [DEFAULT_GLOBAL_STATE[ENTITIES.FIREPLACE.CABIN]],
		video: [DEFAULT_GLOBAL_STATE[ENTITIES.FIREPLACE.CABIN]],
	},
	CABIN_WINDOW: {
		audio: [
			DEFAULT_GLOBAL_STATE[ENTITIES.WEATHER.CABIN],
			DEFAULT_GLOBAL_STATE[ENTITIES.FIREPLACE.CABIN],
		],
		video: [DEFAULT_GLOBAL_STATE[ENTITIES.WEATHER.CABIN]],
	},
	CABIN_KITCHEN: {
		audio: [DEFAULT_GLOBAL_STATE[ENTITIES.FIREPLACE.CABIN]],
		video: [],
	},
	CABIN_LIBRARY: {
		audio: [DEFAULT_GLOBAL_STATE[ENTITIES.FIREPLACE.CABIN]],
		video: [DEFAULT_GLOBAL_STATE[ENTITIES.FIREPLACE.CABIN]],
	},
	CABIN_DESK: {
		audio: [
			DEFAULT_GLOBAL_STATE[ENTITIES.WEATHER.CABIN],
			DEFAULT_GLOBAL_STATE[ENTITIES.FIREPLACE.CABIN],
		],
		video: [DEFAULT_GLOBAL_STATE[ENTITIES.WEATHER.CABIN]],
	},
	CABIN_DESK_DRAWER: {
		audio: [DEFAULT_GLOBAL_STATE[ENTITIES.FIREPLACE.CABIN]],
		video: [],
	},
	CABIN_EXIT: {
		audio: [DEFAULT_GLOBAL_STATE[ENTITIES.FIREPLACE.CABIN]],
		video: [],
	},
	CABIN_RADIO: {
		audio: [DEFAULT_GLOBAL_STATE[ENTITIES.FIREPLACE.CABIN]],
		video: [],
	},
	PLANE: {
		audio: [],
		video: [],
	},
	PLANE_RETURN: {
		audio: [],
		video: [],
	},
	INTERACTIVE_CAT: {
		audio: [DEFAULT_GLOBAL_STATE[ENTITIES.FIREPLACE.CABIN]],
		video: [DEFAULT_GLOBAL_STATE[ENTITIES.CABIN_CAT.CABIN]],
	},
	CABANA: {
		audio: [],
		video: [],
	},
	CABANA_BEACH: {
		audio: [],
		video: [],
	},
} as const;
